import { Card, CardContent, CardHeader } from "@/components/ui/card";

const services = [
  {
    title: "ステーブルコイン研修",
    description:
      "ステーブルコインの基礎から実務まで、法人・個人向けの研修プログラムを提供します。",
  },
  {
    title: "ステーブルコインビジネスコンサルティング",
    description:
      "ステーブルコイン導入・活用の戦略策定からビジネス設計まで、経営視点で支援します。",
  },
  {
    title: "ステーブルコイン技術コンサルティング",
    description:
      "発行・管理・連携の技術設計から実装支援まで、技術面のコンサルティングを提供します。",
  },
  {
    title: "システム開発",
    description:
      "ステーブルコイン連携や決済・管理システムなど、要件に応じたシステム開発を請け負います。",
  },
  {
    title: "ステーブルコインインフラ「MBSC」",
    description:
      "自社開発のステーブルコインインフラ「MBSC(Monobundle Stablecoin Core)」で、安定した発行・運用基盤を提供します。",
  },
];

const developmentSteps = [
  {
    title: "要件定義",
    description:
      "ビジネスの目的を深く理解し、必要な機能と優先順位を明確にします。",
  },
  {
    title: "設計",
    description:
      "拡張性と保守性を考慮した、最適なシステムアーキテクチャを設計します。",
  },
  {
    title: "実装",
    description:
      "最新の技術スタックを活用し、高品質なコードで迅速に開発を進めます。",
  },
  {
    title: "運用",
    description:
      "リリース後の安定稼働を支え、継続的な改善とアップデートを行います。",
  },
];

const crossBorderEcConsultingSteps = [
  {
    title: "要件定義",
    description:
      "ストアの多言語・多通貨・配送・SEOの対応状況を診断し、海外で取りこぼしている機会を明らかにします。",
  },
  {
    title: "戦略設計",
    description:
      "進出先の市場特性に合わせ、優先すべき国・言語・チャネルと打ち手をロードマップに落とし込みます。",
  },
  {
    title: "実行支援",
    description:
      "現地語ローカライズからGEO/SEO（AI検索・検索エンジン最適化）、決済・配送体制の整備まで、必要な施策を伴走しながら形にします。",
  },
  {
    title: "グロース",
    description:
      "海外からの流入と購入データをもとに改善を繰り返し、越境売上の最大化を図ります。",
  },
];

const shopifyAppSteps = [
  {
    title: "現地語対応",
    description:
      "ネイティブ品質の翻訳で、進出先の言語に合わせたストア表示を自動で実現します。",
  },
  {
    title: "GEO/SEO（AI検索・検索エンジン最適化）",
    description:
      "国・地域ごとの検索エンジンに最適化し、海外の見込み客に見つけてもらえる状態をつくります。",
  },
  {
    title: "スムーズな導入",
    description:
      "Shopifyに追加するだけで設定が完結し、専門知識がなくてもすぐに使い始められます。",
  },
  {
    title: "継続的なアップデート",
    description:
      "利用データをもとに翻訳精度と表示を継続的に改善し、成果を伸ばし続けます。",
  },
];

const sectionHeaderStyle = {
  backgroundImage:
    "linear-gradient(to right, rgba(128,128,128,0.08) 1px, transparent 1px), linear-gradient(to bottom, rgba(128,128,128,0.08) 1px, transparent 1px)",
  backgroundSize: "24px 24px",
};

export function BusinessSection() {
  return (
    <section className="px-6 py-20 md:px-12">
      <div className="mx-auto max-w-5xl">
        <div
          className="mb-0 overflow-hidden rounded-t-lg border border-border/60 p-6 md:p-8"
          style={sectionHeaderStyle}
        >
          <h2 className="text-lg font-medium tracking-tight text-foreground md:text-xl">
            ステーブルコイン関連事業
          </h2>
        </div>
        <ul className="grid gap-px overflow-hidden rounded-b-lg border-x border-b border-border/60 bg-border/60 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => (
            <li key={s.title} className="group">
              {s.title.includes("MBSC") ? (
                <a
                  href="/service/mbsc"
                  className="block h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                  aria-label="MBSC の詳細を見る"
                >
                  <Card className="h-full rounded-none border-0 bg-card shadow-none transition-all duration-300 hover:bg-muted/15">
                    <CardHeader className="pb-3">
                      <h3 className="text-base font-bold tracking-tight text-foreground">
                        {s.title}
                      </h3>
                    </CardHeader>
                    <CardContent>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {s.description}
                      </p>
                      <div className="mt-4 flex items-center justify-between">
                        <span className="text-xs font-medium text-foreground/70">
                          詳しく見る
                        </span>
                        <div className="h-1.5 w-1.5 rounded-full bg-foreground opacity-20 transition-all duration-300 group-hover:bg-green-500 group-hover:opacity-100" />
                      </div>
                    </CardContent>
                  </Card>
                </a>
              ) : (
                <Card className="h-full rounded-none border-0 bg-card shadow-none transition-all duration-300 hover:bg-muted/15">
                  <CardHeader className="pb-3">
                    <h3 className="text-base font-bold tracking-tight text-foreground">
                      {s.title}
                    </h3>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {s.description}
                    </p>
                    <div className="mt-4 flex justify-end">
                      <div className="h-1.5 w-1.5 rounded-full bg-foreground opacity-20 transition-all duration-300 group-hover:bg-green-500 group-hover:opacity-100" />
                    </div>
                  </CardContent>
                </Card>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

type ServiceProcessStep = {
  title: string;
  description: string;
};

function ServiceProcessSection({
  title,
  intro,
  steps,
  detailHref,
  detailLabel = "詳しく見る",
}: {
  title: string;
  intro?: string;
  steps: ServiceProcessStep[];
  detailHref?: string;
  detailLabel?: string;
}) {
  const placeholderCount = steps.length % 3 === 0 ? 0 : 3 - (steps.length % 3);
  const items = [
    ...steps.map((step) => ({ ...step, empty: false as const })),
    ...Array.from({ length: placeholderCount }, () => ({ empty: true as const })),
  ];

  return (
    <section className="px-6 py-20 md:px-12">
      <div className="mx-auto max-w-5xl">
        <div
          className="mb-0 overflow-hidden rounded-t-lg border border-border/60 p-6 md:p-8"
          style={sectionHeaderStyle}
        >
          <h2 className="text-lg font-medium tracking-tight text-foreground md:text-xl">
            {title}
          </h2>
          {intro ? (
            <p className="mt-3 max-w-2xl text-sm text-muted-foreground leading-relaxed md:text-base">
              {intro}
            </p>
          ) : null}
          {detailHref ? (
            <a
              href={detailHref}
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-foreground/80 transition-colors hover:text-foreground"
            >
              {detailLabel}
              <span className="h-1.5 w-1.5 rounded-full bg-foreground opacity-40" aria-hidden />
            </a>
          ) : null}
        </div>
        <ul className="grid gap-px overflow-hidden rounded-b-lg border-x border-b border-border/60 bg-border/60 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item, i) =>
            item.empty ? (
              <li key={`empty-${i}`} className="hidden sm:block">
                <Card className="h-full rounded-none border-0 bg-card shadow-none" />
              </li>
            ) : (
              <li key={item.title} className="group">
                <Card className="h-full rounded-none border-0 bg-card shadow-none transition-all duration-300 hover:bg-muted/15">
                  <CardHeader className="pb-3">
                    <h3 className="text-base font-bold tracking-tight text-foreground">
                      {item.title}
                    </h3>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                    <div className="mt-4 flex justify-end">
                      <div className="h-1.5 w-1.5 rounded-full bg-foreground opacity-20 transition-all duration-300 group-hover:bg-green-500 group-hover:opacity-100" />
                    </div>
                  </CardContent>
                </Card>
              </li>
            )
          )}
        </ul>
      </div>
    </section>
  );
}

export function CrossBorderEcConsultingSection() {
  return (
    <ServiceProcessSection
      title="越境ECコンサルティング"
      intro="Shopifyストアの海外展開を、技術の力で支援します。"
      steps={crossBorderEcConsultingSteps}
    />
  );
}

export function ShopifyAppSection() {
  return (
    <ServiceProcessSection
      title="Shopifyアプリ開発・提供"
      intro="ストアの海外対応を、インストールするだけで実現するアプリを提供します。"
      steps={shopifyAppSteps}
      detailHref="/service/ec"
      detailLabel="Autranslate を見る"
    />
  );
}

export function DevelopmentSection() {
  return <ServiceProcessSection title="システム開発" steps={developmentSteps} />;
}
